import _ from 'underscore';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useFormService } from '../core/form-service';
import { FORM_STATES, FORM_EVENTS } from '../machine/machine-config';
import { isPromise } from './is-promise';

export const ViewFetcher = ({ isViewFetched, setIsViewFetched }) => {
  const [chunkError, setChunkError] = useState(null);
  const { state, send } = useFormService();
  const config = _.get(state, ['context', 'config']);
  const { view } = config;

  const isFetching = state.matches(FORM_STATES.FETCHING);

  useEffect(() => {
    if (!isViewFetched && isFetching) {
      let viewPromise;

      if (_.isFunction(view)) {
        try {
          viewPromise = view();
        } catch (e) {
          // if error is thrown, then view could already be loaded
        }
      }

      if (!viewPromise || !isPromise(viewPromise)) {
        setIsViewFetched(true);
        return;
      }
      // If view is a promise, then we need to wait for it to resolve
      view().then((resolvedView) => {
        setIsViewFetched(true);
        send(FORM_EVENTS.UPDATE_CONFIG, { config: { view: resolvedView } });
      }).catch((e) => {
        if (e && e.name === 'ChunkLoadError') {
          setChunkError(e);
        }
      });
    }
  }, [isFetching, isViewFetched, send, setIsViewFetched, view]);

  useEffect(() => {
    if (chunkError) {
      throw chunkError;
    }
  }, [chunkError]);

  return null;
};

ViewFetcher.propTypes = {
  isViewFetched: PropTypes.bool.isRequired,
  setIsViewFetched: PropTypes.func.isRequired,
};
